import React, {Component} from 'react'
import PropTypes from "prop-types"
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import ReactQuill from 'react-quill'
import {modules, getYouTubeSrcFromId} from './utils'
import {youTubeGetID} from '../../../../helpers/common'
import {ADD_MEDIA, showModal} from '../../../../modules/modals'
import {handleQuestionSave, handleQuestionCopy} from '../../../../modules/questions'
import AddImage from './AddImage'


const Clipboard = ReactQuill.Quill.import('modules/clipboard');
const Delta = ReactQuill.Quill.import('delta');

class PlainClipboard extends Clipboard {
    onPaste (e) {
        e.preventDefault()
        const range = this.quill.getSelection()
        const text = e.clipboardData.getData('text/plain')
        const delta = new Delta()
        .retain(range.index)
        .delete(range.length)
        .insert(text)
        const index = text.length + range.index
        const length = 0
        this.quill.updateContents(delta, 'silent')
        this.quill.setSelection(index, length, 'silent')
        this.quill.scrollIntoView()
    }
  }

ReactQuill.Quill.register('modules/clipboard', PlainClipboard, true)

// @see settings -- config icons
class TextEditor extends Component {

    render() {
        const {viewMode} = this.props;
        const {questionId, showModal, editorType} = this.props
        const readOnlyProp = viewMode ? {readOnly : true} : {}
        return (
            <div className="text-editor">
                {
                    !viewMode &&
                    <div className="editor-media text-right">
                        
                        {/* <span className="editor-media-icon editor-media-icon__video mr-2" onClick={this.showMediaModal('video')} /> */}
                        {/* <span className="editor-media-icon editor-media-icon__image" onClick={this.showMediaModal('image')} /> */}
                        <AddImage 
                            addMedia={this.addMedia('image')}
                            questionId={questionId}
                            editorType={editorType}
                            mediaType='image'
                        >
                            <span className="editor-media-icon editor-media-icon__video mr-2" onClick={this.showMediaModal('video')} />
                        </AddImage>
                    </div>
                }
                <ReactQuill
                    value={this.props.value}
                    onChange={this.onChange}
                    ref = {this.getQuillEditor}
                    modules = {modules}
                    onBlur = {this.handleBlur}
                    {...readOnlyProp}
                />
            </div>
        )
    }

    componentDidMount() {
        this.handleAddListenersToImg()
    }

    componentDidUpdate() {
        this.handleAddListenersToImg()
    }

    handleAddListenersToImg = () => {
        [].slice.apply(this.editorDom.getElementsByTagName('IMG')).forEach(img => {
            img.addEventListener('load', this.props.handleMeasurer)
        })
    }

    getQuillEditor = ref => {
        this.quillRef = ref
        if (this.quillRef) {
            this.editor = this.quillRef.getEditor()
            this.editorDom = findDOMNode(this.quillRef)
        }
    }

    showMediaModal = (type) => () => {
        if (!['video', 'image'].includes(type)) return
        const {questionId, showModal, editorType} = this.props
        if (!['questionBody', 'questionDescription'].includes(editorType)) return
        showModal({
            modalType : ADD_MEDIA,
            modalProps : {
                mediaType : type,
                addMedia : this.addMedia(type),
                questionId,
                editorType
            }
        })
    }
    addMedia = (type) => (src) => {
        if (!['video', 'image'].includes(type)) return
        if (type === 'video') {
            this.insertVideo(src)
        } else {
            this.insertImage(src)
        }
    }

    insertImage = (src) => {
        if (this.editor) {
            this.editor.focus()
            let range = this.editor.getSelection()
            let index = range && range.index ? range.index : 0
            this.editor.insertEmbed(index, 'image', src, "api")
            this.handleMeasurer()
        }
    }

    insertVideo = (src) => {
        if (this.editor) {
            this.editor.focus()
            var range = this.editor.getSelection()
            let index = range && range.index ? range.index : 0
            this.editor.insertEmbed(index, 'video', getYouTubeSrcFromId(youTubeGetID(src)), "api")
            this.handleMeasurer()
        }
    }

    /*
    * TODO
    * sorry, didn't know how to plug in callback
    * */
    handleMeasurer = () => {
        setTimeout(() => {
            this.props.handleMeasurer && this.props.handleMeasurer()
        }, 1500)
    }

    onChange = value => this.props.onChange(value)
    handleBlur = () => {
        const {questionId, handleQuestionSave,handleQuestionCopy, viewMode} = this.props
        if (!viewMode) {
            setTimeout(() => {
                handleQuestionSave({questionId})
            }, 1000);
        }
    }

    static contextTypes = { formatMessage: PropTypes.any }
}

export default connect(
    null,
    {showModal, handleQuestionSave, handleQuestionCopy}
)(TextEditor)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/TextEditor/index.js